import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TcgDashComponent } from './tcg-dash.component';
import { TcgCardModule } from 'app/common/ui/tcg-card/tcg-card.module';
import { Route, RouterModule } from '@angular/router';
import { KButtonModule } from 'app/common/ui/k-button/k-button.module';
import { FormsModule } from '@angular/forms';
import { tcgCardFilterPipe } from 'app/common/pipes/tradingCard.pipe'
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { TranslocoModule } from '@ngneat/transloco';

const routes: Route[] = [
  {
    path: '',
    component: TcgDashComponent
  }
];

@NgModule({
  declarations: [
    TcgDashComponent,
    tcgCardFilterPipe
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    TcgCardModule,
    KButtonModule,
    FormsModule,
    FontAwesomeModule,
    TranslocoModule
  ],
  exports:[
    TcgDashComponent
  ]
})
export class TcgDashModule { 
 constructor(library: FaIconLibrary){
    library.addIconPacks(fas);
  }
}
